





















































import { Component, Vue, Model, Watch, Prop, BasePage } from "@/common";

import { TwTable } from "@/components";

import moment from "moment";
@Component({})
export default class ModuleButtonRegister extends BasePage {
  layoutShow: boolean = false;

  @Model("change") private value: boolean;

  @Watch("value")
  private changeShow(val) {
    this.layoutShow = val;
  }

  @Prop({ default: "" })
  layoutCode: string;

  @Prop({ default: "" })
  layoutName: string;

  @Prop() data: object;

  private onOk() {
    this.$emit("on-ok");
  }

  private close() {
    this.$emit("change", false);
    this.$emit("on-cancel");
  }

  private onOpen() {
    this.actualLayoutName = this.layoutName;
    this.actualLayoutCode = this.layoutCode;

    this.$nextTick(() => {
      this.buttonTable.load({ cModuleCode: this.layoutCode });
    });
  }

  private get buttonTable(): TwTable {
    return this.$refs["buttonTable"] as TwTable;
  }

  showVisibleOnly: boolean = true;

  showEdit: boolean = false;

  actualLayoutCode: string = "";

  actualLayoutName: string = "";

  buttonModel = {
    ID: null,
    cModuleCode: null, // 配置ID
    cModuleName: null, // 配置名称
    cButtonID: null, // 按钮标识
    cButtonName: null // 按钮名称
  };

  rules = {
    cButtonID: [
      {
        required: true,
        type: "string",
        message: "此属性为必输项",
        trigger: "blur"
      }
    ],
    cButtonName: [
      {
        required: true,
        type: "string",
        message: "此属性为必输项",
        trigger: "blur"
      }
    ]
  };

  buttonColumns = [
    {
      label: "按钮名称",
      prop: "cButtonName",
      width: 180,
      align: "center",
      renderHeader: this.renderHeader
    },
    {
      label: "按钮标识",
      prop: "cButtonID",
      width: 180,
      align: "center"
    },
    {
      label: "操作",
      width: 90,
      align: "center",
      render: this.renderOperation
    }
  ];

  renderHeader(h, params) {
    return (
      <span
        style="cursor:pointer"
        onClick={() => {
          this.showEditModal(null); // 合并编辑:表体添加事件
        }}
      >
        列标题
        <i class="el-icon-add" style="margin-left:10px;color:green" />
      </span>
    );
  }

  onDbClick(data) {
    this.showEditModal(data);
  }

  showEditModal(data) {
    const code = this.actualLayoutCode || this.layoutCode;
    const name = this.actualLayoutName || this.layoutName;
    this.buttonModel.ID = null;

    if (!code || !name) {
      this.$message.warning("未定义模块编号,无法添加按钮信息.");
      return;
    }
    this.resetForm("editForm");
    if (data) {
      this.loadForm(this.buttonModel, data);
    }
    this.showEdit = true;
  }

  saveConfig() {
    this.isFormValid("editForm", isValid => {
      if (isValid) {
        const code = this.actualLayoutCode || this.layoutCode;
        const name = this.actualLayoutName || this.layoutName;
        this.buttonModel.cModuleCode = code;
        this.buttonModel.cModuleName = name;

        this.$http
          .post("Base/Module/SaveButtonRegist", {
            buttonModel: this.buttonModel
          })
          .then(res => {
            if (res.data.status === 0) {
              this.buttonTable.load({
                cModuleCode: code
              });
            } else if (res.data.status === 1) {
              this.$message.error(`保存失败:${res.data.msg}`);
            } else {
              this.$message.error(`保存失败:未知异常`);
            }
            this.showEdit = false;
          })
          .catch(err => {
            this.$message.error(`保存失败:${err}`);
          });
      }
    });
  }

  renderOperation(props) {
    return (
      <div style="display:inline;">
        <el-tooltip content="删除" hide-after={1000} placement="bottom">
          <el-button
            style="padding:7px;"
            type="danger"
            icon="el-icon-users"
            onClick={() => {
              this.deleteConfig(props.row.ID);
            }}
          />
        </el-tooltip>
      </div>
    );
  }

  deleteConfig(ID) {
    const code = this.actualLayoutCode || this.layoutCode;
    this.$http
      .post("/System/Module/DeleteButtonRegist", { ID: ID })
      .then(res => {
        if (res.data.status === 0) {
          this.buttonTable.load({
            cModuleCode: code
          });
        } else if (res.data.status === 1) {
          this.$message.error(`删除失败:${res.data.msg}`);
        } else {
          this.$message.error(`删除失败:未知异常`);
        }
      })
      .catch(err => {
        this.$message.error(`删除失败:${err}`);
      });
  }
}
